import Skeleton from '@mui/material/Skeleton';
import TableCell, { TableCellProps } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

interface SkeletonCellSpec {
  variant?: 'text' | 'circular' | 'rectangular';
  width?: number | string;
  height?: number | string;
  center?: boolean;
  cellProps?: TableCellProps;
}

interface SkeletonTableRowsProps {
  rows: number;
  cells: SkeletonCellSpec[];
}

export default function SkeletonTableRows({ rows, cells }: SkeletonTableRowsProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={`skeleton-${rowIndex}`}>
          {cells.map((cell, cellIndex) => (
            <TableCell key={cellIndex} {...cell.cellProps}>
              <Skeleton
                variant={cell.variant ?? 'text'}
                width={cell.width}
                height={cell.height}
                sx={cell.center ? { mx: 'auto' } : undefined}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
